import { render, staticRenderFns } from "./LtkShopAvatar.vue?vue&type=template&id=e3f2d76c"
import script from "./LtkShopAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkShopAvatar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkAvatar: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkAvatar/CLtkAvatar.vue').default})
